import { render, staticRenderFns } from "./FormShelf.vue?vue&type=template&id=40ae71a7&scoped=true"
import script from "./FormShelf.vue?vue&type=script&lang=js"
export * from "./FormShelf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ae71a7",
  null
  
)

export default component.exports